exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".swiper-pagination-bullet{--tw-bg-opacity: 1;background-color:rgb(255 255 255/var(--tw-bg-opacity))}", ""]);

